function isSafari() {
    const isDesktopSafariAgent = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    const isIOS = !window.MSStream && /iPad|iPhone|iPod/.test(navigator.userAgent);
    return isDesktopSafariAgent || isIOS;
}

export default isSafari;